import React, { useState, useEffect } from "react";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Thumbnail from "@amzn/meridian/thumbnail";
import { FormattedMessage } from "react-intl";
import HeaderContent from "../../headerContent/HeaderContent";
import QRCode from "react-qr-code";
import Alert from "@amzn/meridian/alert";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Loader from "@amzn/meridian/loader";
import Text from "@amzn/meridian/text";
import Theme from "@amzn/meridian/theme";
import { useDeviceLayout } from "../../../common/context/DeviceLayoutContext";

function ScanView({
  alias,
  setAlias,
  setShowQRCode,
  tokenValue,
  setAliasError,
}) {
  const [time, setTime] = useState(60);
  const totalTime = 60;
  const percentage = Math.round((time / totalTime) * 100);
  const { isMobile } = useDeviceLayout();
  const widths = isMobile ? "70%" : "100%";

  useEffect(() => {
    setInterval(() => {
      setTime((prevTime) => {
        if (prevTime === 1) {
          setShowQRCode(false);
          setAlias("");
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  }, []);

  const onButtonClick = () => {
    setShowQRCode(false);
    setAlias("");
    setAliasError(false);
  };

  return (
    <Column>
      <HeaderContent />
      <Box
        width="100%"
        type="outline"
        spacing="1000"
        backgroundColor="#E9EBEF"
        spacingInset="400"
      >
        <Row>
          <Alert size="small" type="informational">
            <strong>
              <FormattedMessage
                id="verificationOptions.text.scanPageHeader"
                defaultMessage="Ask associate to scan code below with Dolphin device."
              />
            </strong>
          </Alert>
          {!isMobile && (
            <div className="loader-container" aria-label={`${time} seconds`}>
              <Theme
                tokens={{
                  loaderTrackBackgroundColor: "#B1BAC3",
                }}
              >
                <Loader
                  percentage={100 - percentage}
                  showPercentageText={false}
                />
              </Theme>
              <Text
                className="loader-text"
                tag="p"
                alignment="center"
                aria-hidden="true"
              >
                {time}s
              </Text>
            </div>
          )}
        </Row>
        <Row spacingInset={"100 none none 450"}>
          <p
            style={{
              fontSize: "14px",
            }}
          >
            <FormattedMessage
              id="verificationOptions.text.scanPageSubHeader"
              defaultMessage="Remind associates to logout before the break."
            />
          </p>
        </Row>
        <Row spacingInset={"400 none 400 450"}>
          <Thumbnail
            borderColor="gray"
            size={"small"}
            source={`https://badgephotos.corp.amazon.com/?uid=${alias}`}
          />
          <p>
            <strong>{alias}</strong>
          </p>
        </Row>
        <Row spacingInset={"200 none none 450"}>
          <Column>
            <QRCode
              value={tokenValue}
              bgColor="white"
              fgColor="black"
              style={{ width: widths, height: "auto" }}
            />
            <Row spacing={"300"}>
              <Button size="medium" type="tertiary" onClick={onButtonClick}>
                <FormattedMessage
                  id="verificationOptions.button.cancel"
                  defaultMessage="Cancel"
                />
              </Button>
              <Button size="medium" onClick={onButtonClick}>
                <FormattedMessage
                  id="verificationOptions.button.done"
                  defaultMessage="Done"
                />
              </Button>
            </Row>
          </Column>
        </Row>
      </Box>
    </Column>
  );
}

export default ScanView;



// WEBPACK FOOTER //
// ./src/components/dolphinVerification/verificationWindow/scanView/ScanView.js